<template>
  <div id="popup-wrap">
    <van-popup v-model="isCreateLink" class="popup-wrap">
      <div class="popup-box">
        <div class="popup-title">生成推广位链接</div>
        <div class="padding-b-20">
          <div class="label-title">推广位名称</div>
          <div class="link-wrap">
            <div class="link-box">
              <input type="text" v-model="link" placeholder="请输入不超过16个字符的名称">
            </div>
            <div class="link-btn" @click="copyLink">复制链接</div>
          </div>
        </div>
        <div class="padding-b-20">
          <div class="label-title">推广海报</div>
          <div class="img-box">
            <img :src="poster64" />
          </div>
        </div>
        <div class="padding-t-10">
          <div class="download-wrap">
            <a class="download-btn" :href="poster64" download="邀请海报.jpg">下载海报</a>
          </div>
        </div>
      </div>
    </van-popup>
    <div class="close-wrap" v-if="isCreateLink">
      <img class="close-img" @click="closePopup" src="../../../../../assets/img/h5/pop_close.png" alt="">
    </div>
  </div>
</template>
<script>
import { requestAjax } from '@/api/user'
export default {
  name: "GetLinked",
  data: function () {
    return {
      isCreateLink: false,
      link: '',
      poster:'',
      poster64:'',
      loading:true
    }
  },
  methods: {
    init: function (isCreateLink, row) {
      this.loading = true
      this.isCreateLink = isCreateLink
      this.link = row.h5_link
      this.poster = ''
      this.poster64 = ''
      this.getDownloadImg(row)
    },
    copyLink: function () {
      var that = this
      this.$copyText(this.link).then(function (e) {
        that.$toast.success('复制成功')
        console.log(e)
      }, function (e) {
        that.$toast.fail('复制失败,请升级浏览器版本！')
        console.log(e)
      })
    },
    getDownloadImg(row){
      var that =this;
      requestAjax({app_key:row.app_key}, '/index/promotion/downloadImg', 'post').then(function (response) {
        if(response.code == 200){
          that.poster = response.data.img_url
          that.poster64 = response.data.base64
          that.loading =false
        }else{
          that.loading =false
          that.$toast.fail(response.msg)
        }
      })
    },
    closePopup(){
      this.isCreateLink = false;
    }
  }
}
</script>

<style lang="less" scoped>
  .popup-wrap{
    width: calc(100% - 60px);
    height: calc(100% - 166px);
    border-radius: 8px;
    margin-top: -25px;
    .popup-box{
      height: auto;
      padding: 20px;
      .popup-title{
        font-family: Alibaba-PuHuiTi-M;
        font-size: 18px;
        color: #222222;
        text-align: center;
        padding: 5px 0 25px 0;
      }
      .label-title{
        font-size: 14px;
        color: #666666;
        padding-bottom: 8px;
      }
      .link-wrap{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .link-box{
          width: calc(100% - 77px);
          input{
            background: #FAFAFA;
            border-radius: 1px;
            color: #222222;
            width: 100%;
            height: 44px;
            line-height: 44px;
            padding: 0 12px;
          }
        }
        .link-btn{
          height: 44px;
          line-height: 44px;
          width: 75px;
          background: #FF8622;
          border-radius: 1px;
          color: #FFFFFF;
          text-align: center;
        }
      }
      .img-box{
        text-align: center;
        img{
          width: 42%;
        }
      }
      .download-wrap{
        height: 35px;
        width: 130px;
        margin: 0 auto;
        .download-btn{
          display: block;
          width: 100%;
          background: #FF8622;
          border-radius: 20px;
          text-align: center;
          line-height: 35px;
          color: #FFFFFF;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/manage/modal/GetLinked.vue